const contactBlockForm = ({ el }) => {
   const fileButtons = [...el.querySelectorAll('[data-contact-file-button]')];
   fileButtons.forEach(fileButton => {
      fileButton.addEventListener('change', (event) => {
         const files = [...event.target.files];
         if (files) {
            const content = document.createElement('div');
            content.classList.add('contact-form-file-names');
            files.forEach(file => {
               const para = document.createElement('p');
               const text = document.createTextNode(file.name);
               para.append(text);
               content.append(para);
            });
            fileButton.append(content);
         }
      });
   });

   const howHearSelect = el.querySelector('[data-how-hear]');
   const howHearText = el.querySelector('[data-how-hear-other]');
   const formHiddenClass = 'form-styles--hidden';
   if (howHearSelect && howHearText) {
      howHearSelect.addEventListener('change', (event) => {
         const value = event.target.value;
         if (value === 'Other (Please Specify)') {
            howHearText.classList.remove(formHiddenClass);
         } else {
            howHearText.classList.add(formHiddenClass);
         }
      });
   }

   const selectOptions = [...el.querySelectorAll('[data-select]')];
   if (selectOptions.length > 0) {
      selectOptions.forEach(selectOption => {
         const selectInput = selectOption.querySelector('select');
         selectInput.addEventListener('change', () => {
            if (selectInput.value != '') {
               selectInput.classList.add('!text-black');
            } else {
               selectInput.classList.remove('!text-black');
            }
         });
      });
   }

   const currentUrlInput = el.querySelector('.current-page-url');
   const pinnedJobCountInput = el.querySelector('.pinned-job-count');
   const pinnedJobsInput = el.querySelector('.pinned-jobs');
   const pinnedJobsCurrentJob = el.querySelector('.current-job-page');
   if (currentUrlInput) {
      let currentUrlValue;
      const currentUrl = window.location.pathname;
      switch (currentUrl) {
         case '/candidates/':
            currentUrlValue = 'Candidates Page';
            break;
         case '/clients/':
            currentUrlValue = 'Clients Page';
            break;
         case '/contact/':
            currentUrlValue = 'Contact Page';
            break;
         case '/pinned-jobs/':
            currentUrlValue = 'Pinned Jobs Page';
            break;
         case '/':
            currentUrlValue = 'Homepage';
            break;
         default:
            currentUrlValue = currentUrl;
            break;
      }
      currentUrlInput.value = currentUrlValue;
   }
   if (pinnedJobCountInput) {
      const pinnedJobItems = JSON.parse(localStorage.getItem('pinnedJobs')) || [];
      const pinnedJobCount = pinnedJobItems.length;
      pinnedJobCountInput.value = pinnedJobCount;
   }
   if (pinnedJobsInput) {
      const pinnedJobNames = JSON.parse(localStorage.getItem('pinnedJobNames')) || [];
      let pinnedJobNamesString = '';
      if (pinnedJobNames.length > 0) {
         pinnedJobNamesString = '[';
         pinnedJobNames.forEach(name => {
            if (pinnedJobNamesString === '[') {
               pinnedJobNamesString += `${name}]`;
            } else {
               pinnedJobNamesString += ` [${name}]`;
            }
         });
      } else {
         pinnedJobNamesString = 'No Pinned Jobs';
      }
      pinnedJobsInput.value = pinnedJobNamesString;
   }
   if (pinnedJobsCurrentJob) {
      const currentJobTitle = document.querySelector('[data-single-job-title]').innerText;
      pinnedJobsCurrentJob.value = currentJobTitle;
   }

   const formFileSizeButton = el.querySelector('[data-form-file-size-button]');
   if (formFileSizeButton) {
      const fileSizeActiveClass = 'form-file-size-container--active';
      const fileSizeContainer = el.querySelector('[data-form-file-container]')
      formFileSizeButton.addEventListener('click', (event) => {
         event.preventDefault();
         fileSizeContainer.classList.add(fileSizeActiveClass);
      });
      const formFileSizeButtonClose = fileSizeContainer.querySelector('[data-form-file-close-button]');
      formFileSizeButtonClose.addEventListener('click', (event) => {
         event.preventDefault();
         fileSizeContainer.classList.remove(fileSizeActiveClass);
      });
   }
}

export default contactBlockForm;